var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrashCan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 11,
    viewBox: "0 0 9 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#6B7081",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M544.375 510l-.563.55h-2.25c-.337 0-.562.22-.562.55 0 .33.225.55.563.55h7.875c.337 0 .562-.22.562-.55 0-.33-.225-.55-.563-.55h-2.25l-.562-.55h-2.25zm-2.813 2.75v7.15c0 .605.507 1.1 1.125 1.1h5.625c.62 0 1.125-.495 1.125-1.1v-7.15h-7.875zm2.25 1.1c.338 0 .563.22.563.55v4.95c0 .33-.225.55-.563.55-.337 0-.562-.22-.562-.55v-4.95c0-.33.225-.55.563-.55zm3.375 0c.338 0 .563.22.563.55v4.95c0 .33-.225.55-.563.55-.337 0-.562-.22-.562-.55v-4.95c0-.33.225-.55.563-.55z",
    transform: "translate(-541 -510)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashCan);
export default __webpack_public_path__ + "static/media/trash-can.ef11cbaa.svg";
export { ForwardRef as ReactComponent };